/* global axios */
import ApiClient from '../ApiClient';

// Ficha do sócio (R1.21): consulta a FENG pelo CPF do contato, já interpretada pelo backend.
class SocioAPI extends ApiClient {
  constructor() {
    super('fandata/conversations', { accountScoped: true });
  }

  get(conversationId) {
    return axios.get(`${this.url}/${conversationId}/socio`);
  }
}

export default new SocioAPI();
